import axios from "axios";
import imageCompression from "browser-image-compression";
import { v4 as uuidv4 } from "uuid";

const FILE_TYPES = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

export async function uploadLiveaboardImageToMinio(
  liveaboardId: string,
  file: File
): Promise<string> {
  if (!FILE_TYPES.includes(file.type)) {
    throw new Error("Use PNG, JPG or WebP.");
  }

  const compressed = await imageCompression(file, {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  });

  const cleanName = file.name.replace(/[^\w.-]/gi, "").replace(/\s+/g, "_");
  const objectName = `images/${uuidv4()}_${cleanName}`;
  const formData = new FormData();
  formData.append("file", compressed);
  formData.append("objectName", objectName);
  formData.append("liveaboardId", liveaboardId);

  const res = await axios.post("/api/minio/uploadliveaboardphoto", formData);
  if (!res.data?.success || !res.data?.imageURL) {
    throw new Error("Upload failed");
  }
  return res.data.imageURL as string;
}

export async function registerLiveaboardImage(
  liveaboardId: string,
  url: string,
  options?: { title?: string | null; category?: string | null }
) {
  await axios.post(`/api/liveaboards/${liveaboardId}/images`, {
    url,
    title: options?.title ?? null,
    category: options?.category ?? null,
  });
}
